import {AfterViewInit, Component, ViewChild} from '@angular/core';
import {MatTableDataSource, MatTableModule} from '@angular/material/table';
import {MatIconModule} from '@angular/material/icon';
import {MatPaginator, MatPaginatorModule} from '@angular/material/paginator';
import {MatCardModule} from '@angular/material/card';

import {MatSort, MatSortModule} from '@angular/material/sort';
import {MatDividerModule} from '@angular/material/divider';
import {MatSelectModule} from '@angular/material/select';
import {CreerEntiteDialogueComponent} from './creer-entite-dialogue/creer-entite-dialogue.component';
import {MatDialog, MatDialogModule} from '@angular/material/dialog';
import {EntiteService} from '../../../services/entites/entite.service';
import {Entite, InterneExterne, Params} from '../../../models/entite/EntiteResponse';
import {CommonModule} from '@angular/common';
import {merge, startWith, tap} from 'rxjs';

import {ModifierEntiteDialogueComponent} from './modifier-entite-dialogue/modifier-entite-dialogue.component';
import {BreadcrumbComponent} from '../../breadcrumb/breadcrumb.component';

@Component({
  selector: 'app-entites',
  templateUrl: './entites.component.html',
  styleUrl: './entites.component.scss',
  standalone: true,
  imports: [
    MatTableModule, MatIconModule, MatSortModule, MatPaginatorModule, MatCardModule, MatDividerModule,
    MatSelectModule, MatDialogModule, CommonModule, BreadcrumbComponent
  ]
})
export class EntitesComponent implements AfterViewInit {
  displayedColumns: string[] = ['libelle', 'interne', 'creation_datetime', 'actions'];
  displayedColumnsFiltre: string[] = ['filter-libelle', 'filter-interne', 'emptyForDateCreation', 'emptyForActions'];
  dataSource = new MatTableDataSource<Entite>();
  filterStatus = '';
  filterType = '';

  @ViewChild(MatSort) sort?: MatSort;
  @ViewChild(MatPaginator) paginator?: MatPaginator;

  constructor(public dialog: MatDialog, private entiteService: EntiteService) {
  }

  ngAfterViewInit() {
    if (this.sort && this.paginator) {
      this.sort.sortChange.subscribe(() => (this.paginator!.pageIndex = 0));

      merge(this.sort.sortChange, this.paginator.page)
        .pipe(
          startWith(null),
          tap(() => this.loadEntities())
        )
        .subscribe();
    } else {
      this.loadEntities();
    }
  }

  loadEntities() {
    if (this.paginator && this.sort) {
      const params: Params = {
        page: this.paginator.pageIndex + 1,
        limit: this.paginator.pageSize,
        actif: this.filterStatus,
        interne: this.filterType,
        orderBy: 'libelle',
        direction: 'asc'
      };

      if (this.sort.active && this.sort.direction !== '') {
        params['orderBy'] = this.sort.active;
        params['direction'] = this.sort.direction;
      }

      this.entiteService.getEntities(params).subscribe({
        next: (entities) => {
          this.dataSource.data = entities.data;
          this.paginator!.length = entities.total;
        },
        error: (error) => {
          console.error('Erreur lors de la récupération des entités', error);
        }
      });
    }
  }

  getInterneExterneLabel(isInterne: boolean): string {
    return isInterne ? InterneExterne.Interne : InterneExterne.Externe;
  }

  applyFilter(value: string, filterType: string): void {
    if (filterType === 'libelle') {
      this.filterStatus = value;
    } else if (filterType === 'type') {
      this.filterType = value;
    }
    this.paginator!.pageIndex = 0;
    this.loadEntities();
  }

  openCreateDialog(): void {
    const dialogRef = this.dialog.open(CreerEntiteDialogueComponent, {
      width: '1200px',
      height: '420px'
    });

    dialogRef.afterClosed().subscribe(result => {
      this.loadEntities();
    });
  }

  openEditDialog(entite: Entite): void {
    const dialogRef = this.dialog.open(ModifierEntiteDialogueComponent, {
      width: '1200px',
      height: '420px',
      data: {entite}
    });

    dialogRef.afterClosed().subscribe(result => {
      this.loadEntities();
    });
  }
}
